"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UFOVehicleDetailsFormProvider = void 0;
var react_1 = __importDefault(require("react"));
var UFOVehicleDetailsFormContext_1 = require("./UFOVehicleDetailsFormContext");
var UFOVehicleDetailsFormProvider = function (props) {
    var countryCode = props.countryCode, fetchYears = props.fetchYears, fetchMakes = props.fetchMakes, fetchModels = props.fetchModels, fetchOptions = props.fetchOptions, fetchTireSizes = props.fetchTireSizes, fetchStates = props.fetchStates, fetchCustomTireSizeSizes = props.fetchCustomTireSizeSizes, fetchCustomTireSizeAspectRatios = props.fetchCustomTireSizeAspectRatios, fetchCustomTireSizeDiameters = props.fetchCustomTireSizeDiameters, fetchCustomTireSizeLoads = props.fetchCustomTireSizeLoads, fetchCustomTireSizeSpeedRatings = props.fetchCustomTireSizeSpeedRatings, children = props.children;
    var formContextValue = UFOVehicleDetailsFormContext_1.useUFOVehicleDetailsFormContextValue({
        countryCode: countryCode,
        fetchYears: fetchYears,
        fetchMakes: fetchMakes,
        fetchModels: fetchModels,
        fetchOptions: fetchOptions,
        fetchTireSizes: fetchTireSizes,
        fetchStates: fetchStates,
        fetchCustomTireSizeSizes: fetchCustomTireSizeSizes,
        fetchCustomTireSizeAspectRatios: fetchCustomTireSizeAspectRatios,
        fetchCustomTireSizeDiameters: fetchCustomTireSizeDiameters,
        fetchCustomTireSizeLoads: fetchCustomTireSizeLoads,
        fetchCustomTireSizeSpeedRatings: fetchCustomTireSizeSpeedRatings,
    });
    return (react_1.default.createElement(UFOVehicleDetailsFormContext_1.UFOVehicleDetailsFormContext.Provider, { value: formContextValue }, children));
};
exports.UFOVehicleDetailsFormProvider = UFOVehicleDetailsFormProvider;
//# sourceMappingURL=UFOVehicleDetailsFormProvider.js.map